module.exports = __webpack_public_path__ + "img/ysh.dd9e4452.png";